import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArion = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 240,
	height: 240,
	viewBox: "0 0 240 240",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M62.963 173.035V118.85C62.963 118.85 62.963 118.591 62.7037 118.591H62.4444L8 173.035V173.295L8.25926 173.554H62.4444V227.48C62.4444 227.48 62.4444 227.739 62.7037 227.739H62.963L117.407 173.295V173.035L117.148 172.776H62.963V173.035Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.4444 113.148C62.7037 113.148 62.7037 113.148 62.7037 113.148L62.963 112.889V58.963H117.148C117.148 58.963 117.407 58.963 117.407 58.7037V58.4444L62.963 4H62.7037C62.4444 4 62.4444 4.25926 62.4444 4.25926V58.4444H8.25926H8V58.7037L62.4444 113.148Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.037 58.963V112.889C177.037 112.889 177.037 113.148 177.297 113.148H177.556L232 58.7037V58.4444L231.741 58.1852H177.556V4.25926C177.556 4.25926 177.556 4 177.297 4H177.037L122.852 58.4444V58.7037L123.111 58.963H177.037Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M174.445 115.739L120 61.2949C120 61.2949 119.741 61.2949 119.482 61.2949L65.2964 115.739C65.2964 115.739 65.2964 115.999 65.2964 116.258L119.482 170.702H119.741H120L174.445 116.258C174.704 115.999 174.704 115.999 174.445 115.739Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M177.556 118.854H177.297L177.037 119.114V173.04H123.111C123.111 173.04 122.852 173.04 122.852 173.299V173.558L177.297 228.003H177.556L177.815 227.743V173.558H231.741C231.741 173.558 232 173.558 232 173.299V173.04L177.556 118.854Z",
			fill: "currentColor"
		})
	]
});
export default SvgArion;
